import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import db from "../dbconn";
import Modal from 'react-responsive-modal';
import {withTranslation} from 'react-i18next';
import i18n from "i18next";
class orderAdded extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            windowHeight: 0,
            nosessionredirect: false,
            categoryList: [],
            open: false
        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {

        var categroyUrl = '';

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        if (sessionStorage.getItem('guestFlag') == 'Y') {
        } else {
            var dbconn = new db();

            dbconn.getAll().then(data => {
                if (!data || data.length < 1) {
                    this.setState({nosessionredirect: true});
                }
            });
        }
    }

    componentDidMount() {

        document.title = "Order Placed - " + localStorage.getItem("store_name") + " - Tria Commerce";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});

        $('#submitBtn').click(e => {

            this.setState({redirect: true});
        });
    }

    render() {
        const {t} = this.props;
        const {open} = this.state;

        var inst = localStorage.getItem("store_curbside_desc");
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        if (this.state.redirect) {
            return (<Redirect to={'/menu'}/>);
        }

        return (
            <div className="mainContainer">
                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">

                        <h2 className="text-center m-2-0"><strong>{t('checkout')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white h-100 middleContent" style={{
                    height: "100vh", position: "fixed",
                    width: "100%"
                }}>
                    <div className="simple-box m-b-0 p-b-35 bkg-white m-grey full-height"
                         style={{height: "100vh", overflowY: "scroll"}}>
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{t('order_success')}</h2>
                                </div>
                                <div className="header-content order_content">
                                    <p className="font-family-bold"><strong>{t('order_thankyou')}</strong></p>
                                    <p className="p-t-10">{t('order_confirmation')}</p>
                                </div>
                                {(sessionStorage.getItem("orderType") == "C") ?
                                    <div className="header-content p-b-10">
                                        <p><strong>{t('curbside_information')}</strong></p>
                                        <p>{inst}</p>
                                    </div>
                                    : ''}
                            </div>
                            <div className="clearfix"></div>
                            <div className="form-group w-60-d m-t-0 w-60-d1">
                                <input type="button" name="submitBtn" id="submitBtn" value={t('start_new_order')}/>
                            </div>
                        </form>
                    </div>
                </div>
                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('submitting_order')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
            </div>
        );
    }
}

export default withRouter(withTranslation()(orderAdded));



// WEBPACK FOOTER //
// ./src/view_components/checkout_confirm.js